const toggleHeader = ({ commit }, payload) => {
  commit('SET_SHOW_HEADER', payload);
};

export default toggleHeader;
